export default class FileNameHelper {
  public static renameFileWithEnding(newFileName: string, currentFileName: string): string {
    const splitName = currentFileName.split(".");
    if (splitName.length === 1) {
      return newFileName;
    }
    return `${newFileName}.${splitName.pop()}`;
  }

  public static postfixFileBeforeEnding(postfix: string, currentFileName: string): string {
    const splitName = currentFileName.split(".");
    if (splitName.length === 1) {
      return currentFileName + postfix;
    }
    const fileExtension = splitName.pop();
    const fileName = splitName.join(".");
    return `${fileName}${postfix}.${fileExtension}`;
  }
}
